import InfoIcon from '../../../../../../ui/svg/common/info';
import React from 'react';
import { ICartItem } from '../../../interfaces';

interface ICartItemNotification{
    cartItem: ICartItem,
    classes?: string,
}

const CartItemNotification = (props: ICartItemNotification) => {
    const { cartItem, classes } = props;

    return (
        <div className={`flex items-center text-red mb-2 ${ classes ? classes : '' }`}>
            <InfoIcon width="17px" color="#ff4f4f" />
            <span className="ml-2" dangerouslySetInnerHTML={{ __html: cartItem.cartNotification }} />
        </div>
    )
};

export default CartItemNotification;